import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PatientService } from 'src/app/shared/patient-service/patient.service';
import { UrlModal } from 'src/app/shared/url.model';
import * as moment from 'moment';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-singledok',
  templateUrl: './singledok.component.html',
  styleUrls: ['./singledok.component.css']
})
export class SingledokComponent implements OnInit {
dokId:any;
  dokData:any;
  serverip: string;
  
  curIndex: any;
  clinicId: any[];
  userToken: string;
  token: string;
  id: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private patservice:PatientService,
    private authService: AuthService,
    ) { }

  ngOnInit(): void {
    this.serverip =UrlModal._URL;
    // this.authService.authDataSubject.pipe(take(1)).subscribe(authData => {
    //   this.userToken = authData._token;
    //   this.id = authData._id;
    //   console.log(this.id);
    // });
    // this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
    //   (this.id = res._id), (this.token = res._token);
    // });
    this.serverip =UrlModal._URL;
    this.route.queryParams.subscribe(params => {
      this.dokId = params['id'];
      console.log('doctorid',this.dokId);
      this.patservice.singledokData(this.dokId).subscribe((result)=>{
           this.dokData=result.data 
           console.log('dokrData',this.dokData)
           this.curIndex=this.dokData.clinicId
           console.log('clinic dta',this.curIndex)
           console.log('doki',this.curIndex.clinicName )
      })
      });
  }
  changeclinic(index, cid) {
    console.log('index of clinic', index);
    this.dokData = this.dokData[index];
    this.curIndex = index;
    this.clinicId = cid;
    console.log('Change Clinic', this.dokData);
    localStorage.setItem('activeClinic', JSON.stringify(this.clinicId));
    console.log(this.clinicId);
  }
}
